import './App.css';
import Footer from './Components/Footer/Footer';
import Navbar from './Components/Navbar/Navbar';
import Location from './Components/Location/Location';
import Banners from './Components/Banners/Banners';

import ShopCategory from './Context/ShopCategory'

import { BrowserRouter,Routes,Route } from 'react-router-dom';
import Important from './Components/Products/Important/Important';
import SecondHand from './Components/Products/SecondHand/SecondHand';
import ProductPage from './Pages/ProductPage/ProductPage';

function App() {
  return (
    <div>
      <BrowserRouter>
        <Navbar/>
        <Routes>
          <Route path='/' element={<> <Banners/> <Important/> <SecondHand/> <Location/> <Footer/> </>}/>
          <Route path='/categories/:category' element={<ShopCategory/>}/>
          <Route path='/product/:productName' element={<ProductPage/>}/>
        </Routes>     
      </BrowserRouter>
    </div>
  );
}

export default App;
